module.exports = __webpack_public_path__ + "static/organicpinkfloral-d5c7e08bb084a7687b37b73dd6d4b2bb.jpeg";